<template>
	<div id="type-checkd">
		<!--<div @click="changeBoxCreate" class="create" v-if="!url" :class="`type ${wideIcon ? 'wide' : ''}`">
			<span :class="`${iconCollection} fa-${iconName} icon`"></span>
			<span class="title">{{ title }}</span>
		</div>-->
		<div v-if="url">
			<input class="checkbox-tools" type="checkbox" name="types" :id="`${id}`">
			<label class="mark-radio-types" :for="`${id}`" @click="changeTipo(id)">
				<i :class="`${iconName} icon iconType`"></i>
				{{ title }}
			</label>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TypeButton',
	props: {
		iconCollection: { type: String, default: 'fas' },
		iconName: { type: String, default: '' },
		title: { type: String, default: '' },
		wideIcon: { type: Boolean, default: false },
		id: { type: String, default: '' },
		url: { type: String, default: '' }
	},
	data () {
		return {
			boxCadastro: this.$attrs.boxCadastro
		}
	},
	methods: {
		changeBoxCreate () {
			this.boxCadastro = !this.boxCadastro
			this.$emit('boxCreate', this.boxCadastro)
		},
		changeTipo (id) {
			console.log('fdsfd', id)
			this.$emit('changeTipo', id)
		}
	}
}
</script>

<style lang="scss" scoped>
#type-checkd {
	margin: 0 5.5px 25px;
	// a, .create {
	// 	&.type {
	// 		display: inline-flex;
	// 		flex-wrap: wrap;
	// 		align-items: center;
	// 		align-content: center;
	// 		justify-content: center;
	// 		width: 85px;
	// 		height: 40px;
	// 		margin: 0 5.5px;
	// 		border-radius: 5px;
	// 		background-image: linear-gradient(45deg, #051D4D 50%, #0083CB);
	// 		background-position: 470px 0;
	// 		background-size: 400% 100%;
	// 		text-decoration: none;
	// 		color: #fff;
	// 		cursor: pointer;
	// 		transition: 0.333s all;

	// 		@media all and (max-width: 1100px) {
	// 			background-image: unset;
	// 			background-color: #025491;

	// 			&:hover, &.wide:hover {
	// 				background-color: #051D4D;
	// 			}
	// 		}

	// 		&:first-child {
	// 			margin-left: 0;
	// 		}

	// 		&:last-child {
	// 			margin-right: 0;
	// 		}

	// 		&:hover {
	// 			background-position: 450px 0;
	// 		}

	// 		&.wide {
	// 			width: 150px;
	// 			background-position: 790px 0;
	// 			background-size: 360% 100%;
	// 			background-image: linear-gradient(55deg, #224894 45%, #00F3F3);

	// 			@media all and (max-width: 1100px) {
	// 				background-image: unset;
	// 				background-color: #53B3FF;
	// 			}

	// 			&:hover {
	// 				background-position: 600px 0;
	// 				background-size: 300% 100%;
	// 			}
	// 		}

	// 		span.title {
	// 			width: 100%;
	// 			align-self: flex-end;
	// 			font-family: "Roboto", sans-serif;
	// 			font-weight: bold;
	// 			font-size: 12px;
	// 			text-align: center;
	// 		}

	// 		span:not(.title)::before {
	// 			display: block;
	// 			font-size: 14px;
	// 			padding-top: 7px;
	// 		}
	// 	}
	// }
	[type="checkbox"]:checked,
	[type="checkbox"]:not(:checked){
		position: absolute;
		left: -9999px;
		width: 0;
		height: 0;
		visibility: hidden;
	}
	.checkbox-tools {
		&:not(:checked) + label {
			border-radius: 5px;
			background: transparent linear-gradient(1deg, #051D4D 0%, #0083CB 100%) 0% 0% no-repeat padding-box;
			padding: 10px;
			width: 95px;
			box-shadow: 0px 3px 6px #00000029;
			color: #fff;
		}
		&:checked + label {
			border-radius: 5px;
			background-color: #08C7DA;
			padding: 10px;
			width: 95px;
			box-shadow: 0px 3px 6px #00000029;
			color: #fff;
		}
	}
	.create {
			border-radius: 5px;
			background: transparent linear-gradient(1deg, #051D4D 0%, #0083CB 100%) 0% 0% no-repeat padding-box;
			padding: 5px;
			width: 125px;
			box-shadow: 0px 3px 6px #00000029;
			color: #fff;
			position: relative;
			top: 12px;
			.fas {
				margin-right: 4px;
			}
	}
	@media all and (max-width: 1100px) {

	}
}

.mark-radio-types{
	cursor:pointer
}
</style>
